/**
 * GuestReviews — a single, quiet "Guest Reviews" strip.
 * No CMS, no animation, no carousel — per spec.
 * Six short excerpts faithful to the original guest reviews on the linked listings.
 */
const REVIEWS = [
  {
    name: "Lissa",
    source: "Airbnb",
    quote: "A really great stay. Clear check-in instructions, spotless apartment, all the amenities and a very comfortable bed. The area was perfect for us — overall a perfect stay.",
  },
  {
    name: "Ryan",
    source: "Airbnb",
    quote: "Very responsive host and a great place to stay.",
  },
  {
    name: "Corey",
    source: "Airbnb",
    quote: "Gianluca was very friendly, helpful and responsive during our stay. Would definitely recommend and stay again.",
  },
  {
    name: "Marine",
    source: "Airbnb",
    quote: "Gianluca was very responsive and helpful. He was also thoughtful — a bouquet of flowers on the kitchen counter made the place feel like home.",
  },
  {
    name: "Taciana",
    source: "Airbnb",
    quote: "A pleasant stay. The location is very good, the host was welcoming, and the apartment was clean and had everything we needed.",
  },
];

const Stars = () => (
  <span aria-label="Five stars" className="text-[var(--ed-emerald)] tracking-[0.25em] text-sm">
    ★★★★★
  </span>
);

export default function GuestReviews() {
  return (
    <section
      id="guest-reviews"
      data-testid="home-guest-reviews"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="ed-container">
        <header className="max-w-2xl mb-12 lg:mb-16">
          <p className="ed-overline mb-3">Guest Reviews</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight text-[var(--ed-ink)]">
            Words from{" "}
            <em style={{ color: "var(--ed-emerald)", fontStyle: "italic", fontWeight: 400 }}>
              recent guests.
            </em>
          </h2>
          <p className="ed-body mt-4">
            Verified reviews from guests who stayed with us through Airbnb.
          </p>
        </header>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"
          data-testid="guest-reviews-grid"
        >
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`guest-review-${i}`}
              className="bg-white border border-[var(--ed-rule)] p-7 lg:p-8 flex flex-col"
            >
              <Stars />
              <blockquote className="mt-5 mb-6 font-serif text-[1.05rem] lg:text-[1.15rem] leading-relaxed text-[var(--ed-ink)] flex-1">
                &ldquo;{r.quote}&rdquo;
              </blockquote>
              <figcaption className="pt-4 border-t border-[var(--ed-rule)] flex items-baseline justify-between gap-3">
                <span className="font-serif text-base text-[var(--ed-ink)]">{r.name}</span>
                <span className="font-sans text-[0.6rem] tracking-[0.28em] uppercase text-[var(--ed-ink-muted)]">
                  {r.source}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
